(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jr-instagram-feed"] && !Shopify.designMode) return;
  try {
    
(function(){
  const section = document.querySelector('[data-section-id="{{ section.id }}"]');
  if(!section) return;

  const grid = section.querySelector('[data-jr-ig-grid]');
  const modal = section.querySelector('[data-jr-ig-modal]');
  const img = section.querySelector('[data-jr-ig-img]');
  const cap = section.querySelector('[data-jr-ig-caption]');
  const link = section.querySelector('[data-jr-ig-link]');
  const closeEls = section.querySelectorAll('[data-jr-ig-close]');

  const source = (grid?.dataset.source || 'api').toLowerCase();
  const username = grid?.dataset.username || 'jr.shoe';
  const token = grid?.dataset.token || '';
  const limit = parseInt(grid?.dataset.limit || '10', 10);

  let lastFocus = null;

  function openModal({image, caption, url}){
    lastFocus = document.activeElement;

    img.src = image || '';
    img.alt = username;
    cap.textContent = caption || '';
    link.href = url || '#';

    modal.hidden = false;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    const closeBtn = modal.querySelector('[data-jr-ig-close]');
    if(closeBtn) closeBtn.focus();
  }

  function closeModal(){
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.body.style.overflow = '';
    if(lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  closeEls.forEach(el => el.addEventListener('click', closeModal));
  document.addEventListener('keydown', (e) => {
    if(modal.hidden) return;
    if(e.key === 'Escape') closeModal();
  });

  function bindOpens(){
    section.querySelectorAll('[data-jr-ig-open]').forEach(btn => {
      btn.addEventListener('click', () => {
        openModal({
          image: btn.getAttribute('data-image'),
          caption: btn.getAttribute('data-caption'),
          url: btn.getAttribute('data-link')
        });
      });
    });
  }

  // Manual mode: just bind
  if(source === 'manual'){
    bindOpens();
    return;
  }

  // API mode (Instagram Graph API)
  // Requires token. If not, keep skeletons.
  if(!token){
    console.warn('JR Instagram Feed: access_token boş. Section ayarlarından token gir veya Manual kullan.');
    return;
  }

  async function fetchIG(){
    // Graph API: https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,thumbnail_url,permalink&access_token=...&limit=10
    const fields = 'id,caption,media_type,media_url,thumbnail_url,permalink';
    const url = `https://graph.instagram.com/me/media?fields=${encodeURIComponent(fields)}&access_token=${encodeURIComponent(token)}&limit=${encodeURIComponent(limit)}`;

    const res = await fetch(url);
    if(!res.ok) throw new Error('IG fetch failed');
    const json = await res.json();
    return (json && json.data) ? json.data : [];
  }

  function render(items){
    grid.innerHTML = '';

    const take = items.slice(0, limit);
    take.forEach(item => {
      const mediaType = item.media_type || '';
      const imageUrl = (mediaType === 'VIDEO') ? (item.thumbnail_url || item.media_url) : item.media_url;
      const caption = item.caption || '';
      const permalink = item.permalink || '#';

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'jr-ig__item';
      btn.setAttribute('data-jr-ig-open', '');
      btn.setAttribute('data-image', imageUrl);
      btn.setAttribute('data-link', permalink);
      btn.setAttribute('data-caption', caption);
      btn.setAttribute('aria-label', 'Instagram görseli');

      const imgEl = document.createElement('img');
      imgEl.loading = 'lazy';
      imgEl.alt = username;
      imgEl.src = imageUrl;

      btn.appendChild(imgEl);
      grid.appendChild(btn);
    });

    bindOpens();
  }

  fetchIG()
    .then(render)
    .catch((err) => {
      console.warn('JR Instagram Feed error:', err);
      // If API fails, keep skeletons; you can switch to Manual anytime.
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
